import React from 'react';
import _ from 'lodash';
import styled, { keyframes } from 'styled-components';

const SHIMMER_BASE = `rgba(255,255,255,0.04)`;
const SHIMMER_HIGHLIGHT = `rgba(255,255,255,0.09)`;

const shimmer = keyframes`
  0%   { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const Skeleton = styled.div`
  background: linear-gradient(90deg, ${SHIMMER_BASE} 25%, ${SHIMMER_HIGHLIGHT} 50%, ${SHIMMER_BASE} 75%);
  background-size: 800px 100%;
  animation: ${shimmer} 1.5s infinite linear;
  border-radius: 6px;
`;

export function DispensariesLoadingStateRedesign() {
  return (
    <Grid>
      {_.range(0, 6).map((n) => (
        <SkeletonCard key={n}>
          <SkeletonImage />
          <SkeletonBody>
            <SkeletonLine width='70%' height='18px' />
            <SkeletonLine width='45%' height='13px' />
            <SkeletonLine width='55%' height='13px' />
            <SkeletonLine width='100%' height='36px' style={{ marginTop: `auto`, borderRadius: `8px` }} />
          </SkeletonBody>
        </SkeletonCard>
      ))}
    </Grid>
  );
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  ${({ theme }) => theme.breakpoints.down(`xs`)} {
    grid-template-columns: 1fr;
  }
`;

const SkeletonCard = styled.div`
  background: var(--rds-bg-card);
  border: 1px solid var(--rds-border);
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const SkeletonImage = styled(Skeleton)`
  height: 180px;
  border-radius: 0;
`;

const SkeletonBody = styled.div`
  padding: 18px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 140px;
`;

const SkeletonLine = styled(Skeleton)<{ $height?: string; $width?: string }>`
  height: ${({ $height }) => $height || `14px`};
  width: ${({ $width }) => $width || `100%`};
  border-radius: 4px;
`;
